import { Component } from '@angular/core';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationDTO } from 'src/app/models/NotificationDTO.model';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { SidebarService } from 'src/app/services/sidebar.service';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    imports: [CommonModule, RouterModule]
})
export class HomeComponent {
  htmlContent?: string = '';
  sanitizedHtmlContent: SafeHtml = {} as SafeHtml;
  statusNotification?: number =  0;
  public Editor = ClassicEditor;
  alert: Alert = {} as Alert;
  public editorConfig = {
    toolbar: [
      'heading', '|',
      'bold', 'italic', 'underline', '|',
      'fontColor', 'fontBackgroundColor', 'fontSize', 'fontFamily', '|',
      'link', 'bulletedList', 'numberedList', 'alignment', '|',
      'undo', 'redo'
    ],
    fontSize: {
      options: ['tiny', 'small', 'default', 'big', 'huge', '18px', '24px', '36px', '48px']
    },
    fontColor: {
      columns: 5,
      colors: [
        { color: '#FF5733', label: 'Orange' },
        { color: '#C70039', label: 'Red' },
        { color: '#28B463', label: 'Green' },
        { color: '#2E86C1', label: 'Blue' },
        { color: '#581845', label: 'Purple' }
      ]
    },
    fontFamily: {
      options: [
        'default',
        'Arial, Helvetica, sans-serif',
        'Courier New, Courier, monospace',
        'Georgia, serif',
        'Lucida Sans Unicode, Lucida Grande, sans-serif',
        'Tahoma, Geneva, sans-serif',
        'Times New Roman, Times, serif',
        'Verdana, Geneva, sans-serif'
      ]
    }
  };

  canSendSMS: boolean = false;
  
  constructor(public permisionsService:  ValidatePermissionsService,
    private sanitizer: DomSanitizer,
    private notificationService: NotificationService,
    private alertService: AlertService,
    public sidebarService: SidebarService
  ) { }

  public get getCustomersRoute(): string {
    if (this.permisionsService.isCustomerLevel) {
      const userId = this.permisionsService.customerId ?? this.permisionsService.userId;
      return `/customers/customer-account/${userId}`;
    }
    return '/customers';
  }

  public get getDistributorsRoute(): string {
    if (this.permisionsService.isDistributorLevel) {
      const userId = this.permisionsService.distributorId ?? this.permisionsService.userId;
      return `/distributors/distributor-account/${userId}`;
    }
    return this.permisionsService.isAdmin ? '/distributors' : '';
  }


  ngOnInit() {

    
    this.sidebarService.CanSendSMS().subscribe(
      (data) => {

        this.canSendSMS = data.canSendSMS;

      },
      (error) => {


        //this.alertService.error(error);
      }
    );

    this.notificationService.getNotification().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.handleGetNotification(Data);
        } else {
          this.handleError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  handleGetNotification(notification: NotificationDTO){
    this.htmlContent = notification.htmlContent ?? '';
    this.sanitizedHtmlContent = this.sanitizeHtml(this.htmlContent);
    this.statusNotification = notification.status;
  }

  sanitizeHtml(content: string): SafeHtml {
    // Transformar etiquetas <font> a <span> con estilos en línea
    const transformedContent = content
    return this.sanitizer.bypassSecurityTrustHtml(transformedContent);
  }

  handleError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }
}
